/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getFollowers.defs.js'
export * as $defs from './getFollowers.defs.js'
